<template>
  <div class="Budgets">
    <div class="row">
      <budget-card v-for="budget in budgets" :key="budget.id" :budget="budget"></budget-card>
      <div class="row w-100" v-if="isCallingBudgets">
        <div class="col-12 d-flex justify-content-center">
          <spinner  v-if="isCallingBudgets" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Commons/Spinner'
import BudgetCard from '../../_components/_shared/BudgetCard'

import _budgetsHandlerMixin from '../../_mixins/_budgetsHandlerMixin'
export default {
  name: 'ActiveBudgetsIndex',
  components: {
    BudgetCard,
    Spinner
  },
  mixins: [_budgetsHandlerMixin],
  created () {
    this.$store.dispatch('BudgetsStore/clearStore')
      let filters = {
        'status.code': 'ACTIVE'
      }
      this.$store.dispatch('BudgetsStore/setBudgetsFilters', filters)
  }

}
</script>
